import { render, staticRenderFns } from "./MonthStatisticComponent.vue?vue&type=template&id=636f5ae2&"
import script from "./MonthStatisticComponent.vue?vue&type=script&lang=js&"
export * from "./MonthStatisticComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports